<ul class="alarm-row text">
    <li class="td">{{ operation.name }}</li>
    <li class="td center">{{ operation.status }}</li>
    <li class="td center action">
        {{ operation.before }}
        <span class="arrow">&#8594;</span>
        {{ operation.after }}
    </li>
    <li
        class="td fill-half"
        style="padding-left: 10px; display: flex; justify-content: end"
    >
        <button class="border" (click)="emitShowDetail()">DETAILS</button>
    </li>
</ul>
